<script>
import VDataTableHeaderDesktop from 'vuetify/lib/components/VDataTable/VDataTableHeaderDesktop'
import { ECheckbox } from '../index'
import VIcon from 'vuetify/lib/components/VIcon/index'

export default {
  name: 'EDataTableHeaderDesktop',
  extends: VDataTableHeaderDesktop,
  methods: {
    genSelectAll() {
      var _this$checkboxColor

      const data = {
        props: {
          value: this.everyItem,
          indeterminate: !this.everyItem && this.someItems,
          color: (_this$checkboxColor = this.checkboxColor) != null ? _this$checkboxColor : '',
        },
        on: {
          change: (v) => this.$emit('toggle-select-all', v),
        },
      }

      if (this.$scopedSlots['data-table-select']) {
        return this.$scopedSlots['data-table-select'](data)
      }
      return this.$createElement(ECheckbox, {
        staticClass: 'v-data-table__checkbox',
        ...data,
      })
    },
    genSortIcon() {
      return this.$createElement(
        VIcon,
        {
          staticClass: 'v-data-table-header__icon',
          props: {
            size: 18,
          },
        },
        ['icon-arrow-up']
      )
    },
  },
}
</script>
